<template>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card text-center">
                            <div class="card-body">
                                <img style="width:300px;max-width:100%" src="images/maintenance.svg">
                                <h4 class="m-t-10">Page is under maintenance</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        name: 'Maintenance',
        metaInfo: {
            title: 'Maintenance',
            titleTemplate: '%s - Tata Hijau Asri'
        },
        data() {
            return {
                label : 'Maintenance',
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>